import getConfig from 'next/config';
import React, { FC, useMemo } from 'react';

import { Prices } from 'components/Prices/Prices';
import { fontFamilies } from 'components/UI/Font';
import { SearchResult } from 'models/search';
import { formatSeasonFromString } from 'shared/helpers/product';

export const Info: FC<{
  isHome?: boolean;
  product: SearchResult;
}> = props => {
  const {
    isHome,
    product,
    product: { brand, model, season },
  } = props;

  const { publicRuntimeConfig } = getConfig();
  const { newSeasons: newSeasonsStr } = publicRuntimeConfig;
  const newSeasons = useMemo(() => newSeasonsStr.split(',') || [], []);
  const newSeasonPrefix = newSeasons.includes(season) ? 'New season ' : '';

  const formattedSeason = useMemo(() => {
    return formatSeasonFromString(season);
  }, [season]);

  return (
    <div className="info">
      <div className="season">
        {newSeasonPrefix}
        {formattedSeason}
      </div>

      <div className="brand">{brand}</div>

      <div className="model">{model}</div>

      {!isHome && (
        <Prices
          product={product}
          style={{
            beforeReductionPrice: { fontSize: '15px', marginBottom: '5px', spaceBeforeSaleText: '15px' },
            currentPrice: { fontSize: '15px', marginBottom: '3px' },
          }}
        />
      )}

      <style jsx>{`
        .info {
          width: 100%;
          text-align: center;
        }
        
        .info * {
          font-size: 15px;
          line-height: 1.2;
          overflow: hidden;
          margin-bottom: 2px;
        }
       
        .info .brand {
          font-family: ${fontFamilies.bold}
          letter-spacing: 1px;
          text-transform: uppercase;
        }
        
        .info .model {
          color: ${isHome ? 'rgb(153, 153, 153)' : '#000000'};
        }
      `}</style>
    </div>
  );
};
